// OpenFileComponent2.tsx
import React, { useRef, useState } from 'react';
import { Button, Box, Typography } from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

interface OpenFileProps {
  // Функция, которая будет вызвана после выбора файла
  onFileSelect: (file: File) => void;
  title: string;
  // Необязательный пропс для ограничения типов файлов (например, ".csv,.json")
  accept?: string; 
}

const OpenFileComponent: React.FC<OpenFileProps> = ({ onFileSelect, title, accept }) => {
  // useRef для доступа к нативному input[type="file"]
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string | null>(null);

  // 1. Обработчик клика по кнопке MUI, который вызывает клик на скрытом инпуте
  const handleOpenClick = () => {
    fileInputRef.current?.click();
  };

  // 2. Обработчик изменения инпута (выбор файла)
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      setFileName(file.name);
      onFileSelect(file); // Передача выбранного файла родительскому компоненту
      console.log(`Выбран файл: ${file.name}`);
      
      // Сброс значения инпута, чтобы можно было выбрать тот же файл снова
      if (fileInputRef.current) {
          fileInputRef.current.value = '';
      }
    } else {
        setFileName(null);
    }
  };

  return (
    <Box 
      sx={{ 
        display: 'inline-flex',
        alignSelf: 'stretch',
        maxWidth: 400 
      }}
    >
      {/* ⚠️ Скрытый нативный input[type="file"] */}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={accept}
        style={{ display: 'none' }} 
      />

      <Button
        variant="outlined"
        color="primary"
        startIcon={<FolderOpenIcon />}
        onClick={handleOpenClick}
        fullWidth
        sx={{ height: 'inherit' }}
      >
        {title}
      </Button>
    </Box>
  );
};

export default OpenFileComponent;